import React, { useState, useEffect, forwardRef, ReactElement } from 'react';
import api from "../components/api";
import TextInput from '../components/TextInput'
import toast from 'react-hot-toast';


import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";


const Transition = forwardRef(function Transition(
    props: TransitionProps & { children: ReactElement<any, any> },
    ref
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface iArquivos {
    ad_new: string,
    arquivo: string,
    descricao: string,
    documento_id: number,
}

const EmissaoAnexos = (props: any) => {


    const [descricao, setDescricao] = useState<string>('');
    const [arquivo, setArquivo] = useState<File | undefined>();
    const [resultado, setResultado] = useState<React.ReactNode>()
    const [documento_id, setDocumento_id] = useState<number>(0);

    const [open, setOpen] = useState(false);
    const [titulo, setTitulo] = useState('');
    const [frase, setFrase] = useState('');
    const [acao, setAcao] = useState('');

    const [cliente_id, setCliente_id] = useState<number>()
    const [uuid, setUuid] = useState<string>('');

    const dadosUsuarios = sessionStorage.getItem('dadosUsuarios')


    const validaSalvaArquivo = () => {

        if (descricao == '') {
            toast.error('Por favor, informe a descrição do anexo!')
            return false
        }
        if (arquivo == null) {
            toast.error('Por favor, informe o arquivo do anexo!')
            return false
        }

        setOpen(true)
        setTitulo('Confirmação')
        setFrase('Confirma salvar o anexo?')
        setAcao('salvaArquivo')


    }

    const salvaArquivo = () => {

        setOpen(false)

        const formData = new FormData();



        formData.append('descricao', descricao);
        formData.append('cliente_id', props.cliente_id)
        formData.append('emissao_id', props.emissao_id);
        formData.append('tipo', 'emissao');
        formData.append('ad_usr', props.usuario_id)

        if (arquivo) {
            formData.append('arquivo', arquivo); // 'arquivo' deve ser o nome do campo esperado na API
        }

        //console.log(props.cliente_id)
        //return false

        api.post('documentoAnexo', formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Necessário para uploads de arquivos
            },
        })
            .then((result: any) => {

                console.log(result.data)

                if (result.data.status === 'ok') {

                    toast.success('Arquivo anexado com sucesso!');
                    setDescricao('')
                    setArquivo(undefined)
                    const fileInput = document.getElementById('arquivo') as HTMLInputElement;
                    if (fileInput) fileInput.value = '';
                    carregaAnexos()
                    //setStatus('ok');
                    //setOpen(false)
                }
            })
            .catch((err) => {
                console.log(err.response);
            });

    }


    const carregaAnexos = () => {

        var dataPost = {

            cliente_id: props.cliente_id,
            tipo: 'emissao',
            emissao_id: props.emissao_id,

        }

        //console.log(dataPost, 'aqui')

        api.post('documentosAnexos', dataPost).then((result) => {

            //console.log(result.data)
            props.setTotalAnexos(result.data.length)
            setResultado(result.data.map((rs: iArquivos) =>

                <tr>

                    <td style={{ cursor: 'pointer' }} onClick={() => window.open(`${process.env.REACT_APP_API}/${props.cliente_id}/emissao/${props.emissao_id}/${rs.arquivo}`)}>
                        {rs.descricao}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => { setDocumento_id(rs.documento_id); validaApagar() }}>X</button>
                    </td>
                </tr>

            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    const validaApagar = () => {

        setOpen(true)
        setTitulo('Confirmação')
        setFrase('Confirma excluir o anexo?')
        setAcao('apagaAnexo')

    }



    const apagaArquivo = () => {

        setOpen(false)
        //console.log('aqui')

        var dataPost = {
            documento_id: documento_id,
            tipo: 'emissao',
        }

        api.post('documentoAnexoApaga', dataPost).then((result) => {

            if (result.data.status === 'ok') {

                toast.success('Arquivo apagado com sucesso!');
                carregaAnexos()
            }

        }).catch((err) => {

            console.log(err.response)

        })

    }

    useEffect(() => {
        carregaAnexos()
    }, [props.emissao_id])

    useEffect(() => {

        if (dadosUsuarios) {

            var dados = JSON.parse(dadosUsuarios)

            setUuid(dados.uuid)
            setCliente_id(dados.cliente_id)

        }

    }, [dadosUsuarios])

    return (
        <div>

            <div className="row g-3">

                <div className="col-md-5">
                    <label className="form-label">Arquivo *</label>
                    <div className="input-group input-group-sm">
                        <input
                            type="file"
                            className="form-control"
                            accept="application/pdf"
                            id="arquivo"
                            onChange={(event) => {
                                const selectedFile = event.target.files?.[0];

                                if (selectedFile) {
                                    const fileName = selectedFile.name.toLowerCase();
                                    const fileType = selectedFile.type;

                                    if (!fileName.endsWith(".pdf") || fileType !== "application/pdf") {
                                        toast.error('Por favor, apenas arquivos no formato PDF!');
                                        return;
                                    }

                                    setArquivo(selectedFile);
                                } else {
                                    setArquivo(undefined);
                                }
                            }}
                        />
                    </div>

                </div>

                <div className="col-md-7">
                    <label className="form-label">Descrição *</label>
                    <div className="input-group input-group-sm">
                        <input type="text" className="form-control" value={descricao} onChange={event => setDescricao(event.target.value)} maxLength={150} />
                        <button className="btn btn-info" type="button" onClick={validaSalvaArquivo}>Salvar anexo
                        </button>
                    </div>
                </div>

                <div className="col-md-12">

                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left', backgroundColor: '#EFEFEF' }}>

                                    Arquivo

                                </th>

                                <th style={{ backgroundColor: '#EFEFEF', textAlign: 'center' }}>

                                    &nbsp;

                                </th>

                            </tr>

                        </thead>
                        <tbody>

                            {resultado}

                        </tbody>

                    </table>


                </div>

            </div>


            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">{titulo}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column" }}>

                    <div style={{ textAlign: 'justify' }}>
                        {frase}
                    </div>

                </DialogContent>
                <DialogActions>



                    <Button color="error" variant="contained" onClick={() => setOpen(false)} >
                        Cancelar
                    </Button>
                    <Button color="success" variant="contained" onClick={() => acao == 'salvaArquivo' ? salvaArquivo() : apagaArquivo()} >
                        Ok
                    </Button>


                </DialogActions>
            </Dialog>

        </div>
    )
}

export default EmissaoAnexos